import { render, staticRenderFns } from "./MutateAffiliate.vue?vue&type=template&id=1e2f85fa&scoped=true&"
import script from "./MutateAffiliate.vue?vue&type=script&lang=js&"
export * from "./MutateAffiliate.vue?vue&type=script&lang=js&"
import style0 from "./MutateAffiliate.vue?vue&type=style&index=0&id=1e2f85fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2f85fa",
  null
  
)

export default component.exports